import React from "react";
import { Quiz } from "../../../modules/academy/models";

export interface QuizCardProps {
  quiz: Quiz;
  bestScore?: number;
  isGuest: boolean;
  onStartQuiz?: (quizId: string) => void;
}

export function QuizCard({ quiz, bestScore, isGuest, onStartQuiz }: QuizCardProps) {
  const { id, title, duration, level } = quiz;
  const levelLabel = level ? `Niveau: ${level}` : "Niveau libre";
  return (
    <div className="mm-surface p-4 space-y-2">
      <h3 className="text-base font-semibold">{title}</h3>
      <p className="text-xs text-slate-500 dark:text-slate-400">
        {duration ? `${duration} min` : "5 min"} · {levelLabel}
      </p>
      {bestScore !== undefined && (
        <p className="text-sm font-semibold text-emerald-600">Meilleur score: {bestScore}%</p>
      )}
      {isGuest && (
        <p className="text-[11px] text-slate-500 dark:text-slate-400">
          Connectez-vous pour sauvegarder vos scores.
        </p>
      )}
      <button
        type="button"
        className="px-3 py-1.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
        onClick={() => onStartQuiz?.(id)}
      >
        Lancer le quiz
      </button>
    </div>
  );
}
